/**
 * Simple utility to load iframes when needed
 */
function loadIframes() {
	const iframes = document.querySelectorAll('iframe[data-src]');

	if (iframes.length === 0) return;

	iframes.forEach((iframe) => {
		const src = iframe.getAttribute('data-src');
		if (src) {
			iframe.src = src;
		}
	});
}

export { loadIframes };
